var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404BackgroundDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2172,
    height: 576,
    viewBox: "0 0 2172 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1315 159.356C29.1315 159.356 68.6113 185.229 132.174 223.2C151.677 283.381 125.837 351.176 203.639 397.206C411.521 520.21 809.123 735.404 1158.09 381.499C1264.18 273.912 1168.18 253.497 1421.49 75.8363C1674.81 -101.824 1966.59 -284.277 2171.36 -329.144C2088.94 -518.433 1074.05 -431.424 814 -406C302.16 -355.962 397.5 -13.4999 397.5 -13.4999L0.446766 -103.354L29.1315 159.356Z",
    fill: "url(#paint0_linear_93_13999)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_13999",
    x1: 528.5,
    y1: 382,
    x2: 1644,
    y2: 73.5003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35435E",
    stopOpacity: 0.03
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404BackgroundDark);
export default __webpack_public_path__ + "static/media/404_Background_dark.00163f98a94b38442cfc8b0ad9350948.svg";
export { ForwardRef as ReactComponent };